webpackJsonp([4],{

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_filter_vue__ = __webpack_require__(944);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6ab43e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_filter_vue__ = __webpack_require__(1010);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6ab43e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-autocomplete',{attrs:{"background-color":"white","box":"","disabled":_vm.disabled,"height":48,"hide-details":"","item-text":"name","item-value":"id","items":_vm.customers,"label":"Cliente","loading":_vm.isLoading,"readonly":_vm.disabled,"return-object":"","search-input":_vm.search,"value":_vm.newCustomerId},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event},"input":_vm.setCustomerId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_app_date_mask__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_companies_company_filter__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_helper__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_lib__ = __webpack_require__(833);






var addData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(type) {
		var copyType, body, _ref2, response, newResponse, messageType;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						copyType = type === 'modules' ? 'module' : type;

						if (!(this[copyType].code && this[copyType].name || this[copyType].name && this[copyType].value)) {
							_context.next = 30;
							break;
						}

						if (!(copyType === 'module')) {
							_context.next = 24;
							break;
						}

						if (!(this.mode === 'edit')) {
							_context.next = 17;
							break;
						}

						body = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.module);

						body.subsidiaryId = this.companyId;
						body.customerId = this.params.customerId;
						delete body.flagActive;
						_context.next = 10;
						return this.$http.post('type-register', body);

					case 10:
						_ref2 = _context.sent;
						response = _ref2.data;
						newResponse = {
							code: response.code,
							flagActive: false,
							id: response.id,
							name: response.name
						};

						this.model.modules.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, newResponse));
						this.showNotification('Módulo agregado correctamente.');
						_context.next = 21;
						break;

					case 17:
						this[copyType].id = this.model[type].length + 1;
						this[copyType].canRemove = true;
						this[copyType].flagActive = true;
						this.model[type].push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this[copyType]));

					case 21:
						this[copyType] = {
							code: '',
							name: ''
						};
						_context.next = 28;
						break;

					case 24:
						this[copyType].id = this.model[type].length + 1;
						this[copyType].canRemove = true;
						this.model[type].push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this[copyType]));
						this[copyType] = {
							name: '',
							value: ''
						};

					case 28:
						_context.next = 32;
						break;

					case 30:
						messageType = type === 'modules' ? 'módulo' : 'dato adicional';

						this.showGenericError('Se deben completar los dos campos para poder agregar un ' + messageType);

					case 32:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function addData(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadCompanyData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _ref5, record;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$http.get('subsidiary/' + this.companyId + '/detail');

					case 2:
						_ref5 = _context2.sent;
						record = _ref5.data;

						if (record) {
							this.model = {
								activityId: record.activityId,
								additionalData: record.additionalData || [],
								cityId: record.cityId,
								documentNumber: record.documentNumber,
								externalId: record.externalId,
								legalRepresentative: record.legalRepresentative,
								modules: this.getModules(record.modules),
								name: record.name,
								startDateOperations: __WEBPACK_IMPORTED_MODULE_8__shared_helper__["a" /* default */].exactDate(record.startDateOperations, 'YYYY-MM-DD'),
								typeTaxpayerId: record.typeTaxpayerId
							};
							this.valueStartDate = __WEBPACK_IMPORTED_MODULE_8__shared_helper__["a" /* default */].exactDate(record.startDateOperations, 'DD/MM/YYYY');
						}

					case 5:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadCompanyData() {
		return _ref4.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var request, _ref7, _ref8;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						request = [this.$http.get('activities'), this.$http.get('cities'), this.$http.get('regimes'), this.$http.get('module')];
						_context3.next = 3;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 3:
						_ref7 = _context3.sent;
						_ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 4);
						this.activities = _ref8[0].data;
						this.cities = _ref8[1].data;
						this.typeTaxpayers = _ref8[2].data;
						this.model.modules = _ref8[3].data;

						if (this.mode === 'edit') {
							this.loadCompanyData();
						}

					case 10:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadResources() {
		return _ref6.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var _this = this;

		var method, url, newModel;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						this.loading = true;
						method = this.mode === 'create' ? 'post' : 'patch';
						url = this.mode === 'create' ? 'subsidiary/' + this.params.customerId + '/customer' : 'subsidiary/' + this.companyId;
						newModel = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.model);

						newModel.modules = this.model.modules.map(function (mod) {
							var newMod = {
								code: mod.code,
								flagActive: !!mod.flagActive,
								name: mod.name
							};
							if (_this.mode === 'edit') {
								newMod.id = mod.id;
							}
							return newMod;
						});
						newModel.additionalData = this.model.additionalData.map(function (add) {
							var newAdd = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, add);
							delete newAdd.id;
							delete newAdd.canRemove;
							return newAdd;
						});
						_context4.prev = 6;
						_context4.next = 9;
						return this.$http[method](url, newModel);

					case 9:
						this.showNotification('La empresa ha sido creada correctamente.');
						this.closeModal();
						_context4.next = 16;
						break;

					case 13:
						_context4.prev = 13;
						_context4.t0 = _context4['catch'](6);

						if (_context4.t0.status === 500) {
							this.showGenericError();
						} else if (_context4.t0.status === 400) {
							if (_context4.t0.data.message === 'SECTOR_DEFAULT_NOT_FOUND') {
								this.showGenericError('Sector por defecto no encontrado.');
							} else if (_context4.t0.data.message === 'PLAN_TEMPLATE_NOT_EXIST') {
								this.showGenericError('Plan no existente.');
							} else if (_context4.t0.data.message === 'CODE_COMPANY_DUPLICATE') {
								this.showGenericError('El número de documento ya está registrado.');
							}
						}

					case 16:
						_context4.prev = 16;

						this.loading = false;
						return _context4.finish(16);

					case 19:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[6, 13, 16, 19]]);
	}));

	return function submitForm() {
		return _ref9.apply(this, arguments);
	};
}();

var setExternalId = function () {
	var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(event) {
		var ruc, url, _ref11, externalResponse;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						ruc = event.target.value;

						if (!ruc) {
							_context5.next = 14;
							break;
						}

						url = 'subsidiaries/' + ruc + '/ruc-public';
						_context5.prev = 3;
						_context5.next = 6;
						return this.$httpSales.get(url);

					case 6:
						_ref11 = _context5.sent;
						externalResponse = _ref11.data;

						this.model.externalId = externalResponse.id;
						_context5.next = 14;
						break;

					case 11:
						_context5.prev = 11;
						_context5.t0 = _context5['catch'](3);

						if (_context5.t0.data.message === 'SUBSIDIARIES_ERROR') {
							this.showNotification('No existe subsidiaria asociada a ese número de identificación', 'info');
						}

					case 14:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[3, 11]]);
	}));

	return function setExternalId(_x2) {
		return _ref10.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PAGE_COMPANY_LIST = 'companies';

function created() {
	if (this.customerId) {
		this.params.customerId = this.customerId;
	}
	this.loadResources();
}

function closeModal() {
	var customerName = this.$route.params.customerName;

	this.goTo(PAGE_COMPANY_LIST, { params: { customerId: this.customerId, customerName: customerName } });
}

function disabledCompany() {
	var modulesValid = this.model.modules.some(function (mod) {
		return mod.flagActive;
	});
	return this.loading || !modulesValid;
}

function getModules(modules) {
	return __WEBPACK_IMPORTED_MODULE_9__shared_lib__["a" /* default */].map(__WEBPACK_IMPORTED_MODULE_9__shared_lib__["a" /* default */].setNewProperty('flagActive', function (_ref3) {
		var flagActive = _ref3.flagActive;
		return Boolean(flagActive);
	}), modules);
}

function mode() {
	return this.companyId ? 'edit' : 'create';
}

function onDate(value, modelName) {
	this.model[modelName] = value;
}

function removeData(type, index) {
	this.model[type].splice(index, 1);
}

function validations() {
	var validation = {
		params: {
			customerId: {
				minValue: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["minValue"])(1),
				required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
			}
		},
		model: {
			name: {
				required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
			},
			documentNumber: {
				required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
				maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(13)
			},
			modules: {
				minLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["minLength"])(1),
				required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
			}
		}
	};
	return validation;
}

function title() {
	var companyAction = this.companyId ? 'Editar > ' + this.model.name : 'Nueva Empresa';
	return this.customerName + ' > ' + companyAction;
}

function data() {
	return {
		activities: [],
		additionalData: {
			name: '',
			value: ''
		},
		cities: [],
		isLoading: false,
		loading: false,
		model: {
			activityId: null,
			additionalData: [],
			cityId: null,
			documentNumber: null,
			externalId: null,
			legalRepresentative: null,
			modules: [],
			name: null,
			startDateOperations: null,
			typeTaxpayerId: null
		},
		module: {
			code: '',
			flagActive: false,
			name: ''
		},
		typeTaxpayers: [],
		valueStartDate: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-form',
	components: {
		AddButton: function AddButton() {
			return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1291));
		},
		appDateMask: __WEBPACK_IMPORTED_MODULE_6__components_shared_app_date_mask__["a" /* default */],
		BaseCheckBox: function BaseCheckBox() {
			return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1295));
		},
		BaseDate: function BaseDate() {
			return __webpack_require__.e/* import() */(51/* duplicate */).then(__webpack_require__.bind(null, 894));
		},
		BaseInput: function BaseInput() {
			return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 228));
		},
		BaseSelect: function BaseSelect() {
			return __webpack_require__.e/* import() */(50/* duplicate */).then(__webpack_require__.bind(null, 766));
		},
		companyFilter: __WEBPACK_IMPORTED_MODULE_7__components_companies_company_filter__["a" /* default */]
	},
	computed: {
		disabledCompany: disabledCompany,
		mode: mode,
		title: title
	},
	created: created,
	data: data,
	methods: {
		addData: addData,
		closeModal: closeModal,
		loadCompanyData: loadCompanyData,
		loadResources: loadResources,
		getModules: getModules,
		onDate: onDate,
		removeData: removeData,
		setExternalId: setExternalId,
		submitForm: submitForm
	},
	props: {
		companyId: [Number, String],
		customerName: [Number, String],
		customerId: [Number, String]
	},
	validations: validations
});

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("017ee790", content, true, {});

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.title-section[data-v-f57d4a1c]{font-family:Opens_semibold;font-size:13px;padding-left:9px;text-transform:uppercase}hr[data-v-f57d4a1c]{border-color:#d3dde6!important;border-width:1.5px}.error-style[data-v-f57d4a1c]{color:#f42b17}.form[data-v-f57d4a1c]{padding-bottom:40px}", "", {"version":3,"sources":["/opt/build/repo/src/components/companies/company-form.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,gCAAgC,2BAA6B,eAAe,iBAAiB,wBAAwB,CACpH,AACD,oBAAoB,+BAAgC,kBAAkB,CACrE,AACD,8BAA8B,aAAa,CAC1C,AACD,uBAAuB,mBAAmB,CACzC","file":"company-form.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.title-section[data-v-f57d4a1c]{font-family:\"Opens_semibold\";font-size:13px;padding-left:9px;text-transform:uppercase\n}\nhr[data-v-f57d4a1c]{border-color:#d3dde6 !important;border-width:1.5px\n}\n.error-style[data-v-f57d4a1c]{color:#f42b17\n}\n.form[data-v-f57d4a1c]{padding-bottom:40px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-page',{attrs:{"name":"companies-new","title":_vm.title}}),_vm._v(" "),_c('form-sidebar',[_c('v-form',{staticClass:"form"},[_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('label',{staticClass:"title-section"},[_vm._v("Datos de la Empresa")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-0":"","mb-3":""}},[_c('v-divider')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","mb-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('BaseInput',{attrs:{"label":"Nombre de la Empresa","height":38},model:{value:(_vm.$v.model.name.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.name, "$model", $$v)},expression:"$v.model.name.$model"}},[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.$v.$anyDirty && !_vm.$v.model.name.required),expression:"$v.$anyDirty && !$v.model.name.required"}],attrs:{"slot":"error"},slot:"error"},[_vm._v("El nombre es requerido")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mb-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('BaseInput',{attrs:{"label":"Representante Legal","height":38},model:{value:(_vm.model.legalRepresentative),callback:function ($$v) {_vm.$set(_vm.model, "legalRepresentative", $$v)},expression:"model.legalRepresentative"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":"","mb-3":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('BaseInput',{attrs:{"label":"Ruc","height":38,"type":"number"},on:{"blur":_vm.setExternalId},model:{value:(_vm.$v.model.documentNumber.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.documentNumber, "$model", $$v)},expression:"$v.model.documentNumber.$model"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$v.$anyDirty && !_vm.$v.model.documentNumber.required),expression:"$v.$anyDirty && !$v.model.documentNumber.required"}],staticClass:"error--text caption"},[_vm._v("\n\t\t\t\t\t\t\t\tEl número de RUC es requerido\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$v.$anyDirty && !_vm.$v.model.documentNumber.maxLength),expression:"$v.$anyDirty && !$v.model.documentNumber.maxLength"}],staticClass:"error--text caption"},[_vm._v("\n\t\t\t\t\t\t\t\tEl RUC solo puede tener 13 digitos\n\t\t\t\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('BaseDate',{attrs:{"type":"date","label":"Fecha Inicio","height":38},model:{value:(_vm.model.startDateOperations),callback:function ($$v) {_vm.$set(_vm.model, "startDateOperations", $$v)},expression:"model.startDateOperations"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","mb-1":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('BaseSelect',{attrs:{"label":"Actividades","item-text":"name","item-value":"id","height":38,"items":_vm.activities},model:{value:(_vm.model.activityId),callback:function ($$v) {_vm.$set(_vm.model, "activityId", $$v)},expression:"model.activityId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('BaseSelect',{attrs:{"label":"Ciudades","item-text":"name","item-value":"id","height":38,"items":_vm.cities},model:{value:(_vm.model.cityId),callback:function ($$v) {_vm.$set(_vm.model, "cityId", $$v)},expression:"model.cityId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mb-3":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('BaseSelect',{attrs:{"label":"Tipo de Contribuyente","item-text":"name","item-value":"id","height":38,"items":_vm.typeTaxpayers},model:{value:(_vm.model.typeTaxpayerId),callback:function ($$v) {_vm.$set(_vm.model, "typeTaxpayerId", $$v)},expression:"model.typeTaxpayerId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('BaseInput',{attrs:{"readonly":"","label":"Código Externo","height":38},model:{value:(_vm.model.externalId),callback:function ($$v) {_vm.$set(_vm.model, "externalId", $$v)},expression:"model.externalId"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('label',{staticClass:"title-section"},[_vm._v("Datos Adicionales")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-0":"","pb-3":""}},[_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","align-start":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('BaseInput',{attrs:{"label":"Nombre","height":38},model:{value:(_vm.additionalData.name),callback:function ($$v) {_vm.$set(_vm.additionalData, "name", $$v)},expression:"additionalData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('BaseInput',{attrs:{"label":"Valor","type":"number","height":38},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addData('additionalData')}},model:{value:(_vm.additionalData.value),callback:function ($$v) {_vm.$set(_vm.additionalData, "value", $$v)},expression:"additionalData.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('AddButton',{staticClass:"add-btn-container mr-2",on:{"click":function($event){return _vm.addData('additionalData')}}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-space-between":""}},_vm._l((_vm.model.additionalData),function(modelData,index){return _c('v-flex',{key:modelData.id,staticStyle:{"height":"78px"},attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":"","align-start":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('BaseInput',{attrs:{"height":38,"label":"Nombre"},model:{value:(modelData.name),callback:function ($$v) {_vm.$set(modelData, "name", $$v)},expression:"modelData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('BaseInput',{attrs:{"height":38,"label":"Valor"},model:{value:(modelData.value),callback:function ($$v) {_vm.$set(modelData, "value", $$v)},expression:"modelData.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"error--text ma-0",attrs:{"dark":"","icon":"","small":""},on:{"click":function($event){return _vm.removeData('additionalData', index)}}},[_c('img',{attrs:{"src":"/static/img/actions-list/delete.svg","alt":""}})])],1)],1)],1)}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('label',{staticClass:"title-section"},[_vm._v("Módulos Contables")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.$v.$anyDirty && !_vm.$v.model.modules.required),expression:"$v.$anyDirty && !$v.model.modules.required"}],staticClass:"error-style"},[_vm._v("(Almenos un módulo contable es requerido)")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-0":"","pb-3":""}},[_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","align-start":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('BaseInput',{attrs:{"label":"Código","height":38},model:{value:(_vm.module.code),callback:function ($$v) {_vm.$set(_vm.module, "code", $$v)},expression:"module.code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('BaseInput',{attrs:{"label":"Nombre","height":38},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addData('modules')}},model:{value:(_vm.module.name),callback:function ($$v) {_vm.$set(_vm.module, "name", $$v)},expression:"module.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('AddButton',{staticClass:"add-btn-container mr-2",on:{"click":function($event){return _vm.addData('modules')}}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-space-between":""}},_vm._l((_vm.model.modules),function(modelData,index){return _c('v-flex',{key:modelData.id,staticStyle:{"height":"78px"},attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('BaseCheckBox',{attrs:{"height":38,"label":((modelData.code) + "-" + (modelData.name)),"input-value":modelData.flagActive},model:{value:(modelData.flagActive),callback:function ($$v) {_vm.$set(modelData, "flagActive", $$v)},expression:"modelData.flagActive"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"error--text ma-0",attrs:{"dark":"","icon":"","small":""},on:{"click":function($event){return _vm.removeData('modules', index)}}},[_c('img',{attrs:{"src":"/static/img/actions-list/delete.svg","alt":""}})])],1)],1)],1)}),1)],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.disabledCompany},on:{"cancel-button-clicked":_vm.closeModal,"accept-button-clicked":_vm.submitForm}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_form_vue__ = __webpack_require__(1120);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f57d4a1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_form_vue__ = __webpack_require__(1299);
function injectStyle (ssrContext) {
  __webpack_require__(1289)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f57d4a1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f57d4a1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(768));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(791);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(233);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(767));

var _alphaNum = _interopRequireDefault(__webpack_require__(770));

var _numeric = _interopRequireDefault(__webpack_require__(771));

var _between = _interopRequireDefault(__webpack_require__(772));

var _email = _interopRequireDefault(__webpack_require__(773));

var _ipAddress = _interopRequireDefault(__webpack_require__(774));

var _macAddress = _interopRequireDefault(__webpack_require__(775));

var _maxLength = _interopRequireDefault(__webpack_require__(776));

var _minLength = _interopRequireDefault(__webpack_require__(777));

var _required = _interopRequireDefault(__webpack_require__(778));

var _requiredIf = _interopRequireDefault(__webpack_require__(779));

var _requiredUnless = _interopRequireDefault(__webpack_require__(780));

var _sameAs = _interopRequireDefault(__webpack_require__(781));

var _url = _interopRequireDefault(__webpack_require__(782));

var _or = _interopRequireDefault(__webpack_require__(783));

var _and = _interopRequireDefault(__webpack_require__(784));

var _not = _interopRequireDefault(__webpack_require__(785));

var _minValue = _interopRequireDefault(__webpack_require__(786));

var _maxValue = _interopRequireDefault(__webpack_require__(787));

var _integer = _interopRequireDefault(__webpack_require__(788));

var _decimal = _interopRequireDefault(__webpack_require__(789));

var helpers = _interopRequireWildcard(__webpack_require__(763));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'quipu-admin',"APP_NAME":'"Maki-Contable"',"QUIPU_URL":'https://ec-motor.makipos.la',"SALES_URL":'https://ec-pre-sales.makipos.la/',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"COMPANY_FAVICON":'/static/img/icons/favicon-32x32.png',"EXCEL_EXPORT":'/static/',"PRODUCTS_URL":'https://ec-pre-products.makipos.la/',"PRODUCTION_URL":'https://ec-production.makipos.la/',"STORAGE_USER_KEY":"quipu","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl/icons',"COMPANY_LOGIN_TITLE":'Quipu'}).BUILD === 'web' ? __webpack_require__(769).withParams : __webpack_require__(231).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(763);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(792), __esModule: true };

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111);
__webpack_require__(64);
module.exports = __webpack_require__(793);


/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(113);
var ITERATOR = __webpack_require__(14)('iterator');
var Iterators = __webpack_require__(32);
module.exports = __webpack_require__(11).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(14);


/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(11);
var LIBRARY = __webpack_require__(68);
var wksExt = __webpack_require__(794);
var defineProperty = __webpack_require__(30).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(114)('meta');
var isObject = __webpack_require__(31);
var has = __webpack_require__(44);
var setDesc = __webpack_require__(30).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(46)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(242);
var hiddenKeys = __webpack_require__(117).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(49);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["a"] = ({
	isEmpty: function isEmpty(arg) {
		if (Array.isArray(arg)) {
			return arg.length === 0;
		}
		if ((typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(arg)) === 'object' && arg !== null) {
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(arg).length === 0;
		}
		if (typeof arg === 'string' || typeof arg === 'number') {
			return !arg;
		}
		return !arg;
	},
	setNewProperty: function setNewProperty(property, value) {
		return function p(obj) {
			var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
			newObj[property] = typeof value === 'function' ? value(obj) : value;
			return newObj;
		};
	},

	map: function map(fn, col) {
		return col.map(fn);
	},
	getDeeper: function getDeeper() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return function inner(item) {
			var newItem = null;
			if (item && item.length) {
				var _item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(item, 1);

				newItem = _item[0];
			} else {
				newItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);
			}
			args.forEach(function (el) {
				newItem = (newItem || {})[el];
			});
			return newItem;
		};
	}
});

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(845);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(847);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(846), __esModule: true };

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(111);
module.exports = __webpack_require__(794).f('iterator');


/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(848), __esModule: true };

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(849);
__webpack_require__(238);
__webpack_require__(853);
__webpack_require__(854);
module.exports = __webpack_require__(11).Symbol;


/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(12);
var has = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(25);
var $export = __webpack_require__(21);
var redefine = __webpack_require__(241);
var META = __webpack_require__(804).KEY;
var $fails = __webpack_require__(46);
var shared = __webpack_require__(116);
var setToStringTag = __webpack_require__(70);
var uid = __webpack_require__(114);
var wks = __webpack_require__(14);
var wksExt = __webpack_require__(794);
var wksDefine = __webpack_require__(795);
var enumKeys = __webpack_require__(850);
var isArray = __webpack_require__(806);
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(31);
var toObject = __webpack_require__(48);
var toIObject = __webpack_require__(66);
var toPrimitive = __webpack_require__(235);
var createDesc = __webpack_require__(69);
var _create = __webpack_require__(239);
var gOPNExt = __webpack_require__(851);
var $GOPD = __webpack_require__(852);
var $GOPS = __webpack_require__(236);
var $DP = __webpack_require__(30);
var $keys = __webpack_require__(67);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(805).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(230).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(68)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(67);
var gOPS = __webpack_require__(236);
var pIE = __webpack_require__(230);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(66);
var gOPN = __webpack_require__(805).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(230);
var createDesc = __webpack_require__(69);
var toIObject = __webpack_require__(66);
var toPrimitive = __webpack_require__(235);
var has = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(240);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(795)('asyncIterator');


/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(795)('observable');


/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function splitDate(date) {
	return date.split('/');
}

function formatDate(date) {
	if (!date) {
		return null;
	}

	var _splitDate = splitDate(date),
	    _splitDate2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_splitDate, 3),
	    day = _splitDate2[0],
	    month = _splitDate2[1],
	    year = _splitDate2[2];

	return year + '-' + month + '-' + day;
}

function onChange($event, eventName) {
	var value = formatDate($event);
	if (value) {
		this.$emit(eventName, value);
	} else {
		this.$emit(eventName, null);
	}
}

function onInput($event) {
	this.$emit('input', $event);
	var dateValues = splitDate($event);
	if (dateValues && dateValues.length === 3) {
		this.$emit('format-date', __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(dateValues[2], dateValues[1] - 1, dateValues[0]), this.format));
	} else if (dateValues && dateValues.length < 3) {
		this.$emit('format-date', null);
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-date-mask',
	inheritAttrs: false,
	model: {
		prop: 'picker',
		event: 'input'
	},
	props: {
		format: {
			default: 'YYYY-MM-DD',
			type: String
		},
		label: {
			default: '',
			type: String
		},
		mask: {
			default: '##/##/####',
			type: String
		},
		picker: {
			default: null
		}
	},
	methods: {
		onChange: onChange,
		onInput: onInput
	}
});

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_date_mask_vue__ = __webpack_require__(866);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a12b434a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_date_mask_vue__ = __webpack_require__(901);
function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a12b434a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_date_mask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a12b434a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_date_mask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("35244f21", content, true, {});

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.label[data-v-a12b434a]{font-size:12px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-date-mask.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,wBAAwB,cAAc,CACrC","file":"app-date-mask.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.label[data-v-a12b434a]{font-size:12px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 901:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"background-color":"white","hide-details":"","label":_vm.label,"placeholder":"__/__/___","value":_vm.picker},on:{"input":_vm.onInput,"change":function($event){return _vm.onChange($event, 'change')}}},'v-text-field',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	if (this.customerId) {
		this.newCustomerId = this.customerId;
		this.$emit('filter-customer', this.customerId, true);
	}
}

function search(value) {
	if (value) {
		var names = this.customerName.split(' ');
		var validName = names.every(function (n) {
			return n.toLowerCase() !== value.toLowerCase();
		});
		if (validName) {
			this.$emit('filter-customer', value);
		}
	}
}

function setCustomerId(_ref) {
	var id = _ref.id,
	    lastname = _ref.lastname,
	    name = _ref.name,
	    company = _ref.company;

	this.newCustomerId = id;
	var fullName = name + ' ' + lastname;
	this.$emit('set-customer-id', { id: id, fullName: fullName, company: company });
}

function data() {
	return {
		newCustomerId: 0,
		search: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-filter',
	created: created,
	data: data,
	methods: {
		setCustomerId: setCustomerId
	},
	props: {
		customerId: [Number, String],
		customerName: String,
		customers: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		disabled: {
			default: false,
			type: Boolean
		},
		isLoading: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		search: search,
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'companies') {
					if (this.customerId) {
						this.newCustomerId = this.customerId;
						this.$emit('filter-customer', this.customerId, true);
					}
				}
			}
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.a22ea11351bd3d994630.js